import { motion, useReducedMotion } from "framer-motion";

// Entrada al viewport de la landing: fade + 12px, una sola vez.
//
// La regla que manda es que el CONTENIDO NUNCA DEPENDE DE LA ANIMACIÓN. Un `initial={{opacity:0}}`
// deja el bloque invisible hasta que el IntersectionObserver dispare; si no dispara (captura de
// página completa, prerender, bots, navegador sin observer) la sección queda en blanco — lo que se
// vio en Leasity. Por eso hay tres salidas a "sin animación", donde el bloque se pinta tal cual:
// movimiento reducido, falta de IntersectionObserver y navegación automatizada o `?estatico`
// (prerender, capturas).

export const EASE_SALIDA = [0.25, 0.46, 0.45, 0.94];

export function sinAnimacionAutomatica() {
  if (typeof window === "undefined") return true;
  if (!("IntersectionObserver" in window)) return true;
  if (window.__SEBBIA_PRERENDER__) return true;
  // `?estatico` fuerza la página sin animación: lo usa el prerender y sirve para capturas de página
  // completa. `navigator.webdriver` no basta: Chrome con perfil propio lo reporta en `false`.
  try {
    if (new URLSearchParams(window.location.search).has("estatico")) return true;
  } catch {
    /* URL ilegible: se anima */
  }
  try {
    if (navigator.webdriver) return true;
  } catch {
    /* sin navigator: se anima igual */
  }
  return false;
}

export function useSinAnimacion() {
  const reducido = useReducedMotion();
  return reducido || sinAnimacionAutomatica();
}

export const Aparece = ({ as = "div", delay = 0, className, children, ...rest }) => {
  const sinAnimacion = useSinAnimacion();
  if (sinAnimacion) {
    const Tag = as;
    return <Tag className={className} {...rest}>{children}</Tag>;
  }
  const Motion = motion[as] || motion.div;
  return (
    <Motion
      className={className}
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.38, ease: EASE_SALIDA, delay }}
      {...rest}
    >
      {children}
    </Motion>
  );
};
